// PL
export const hotelRoomsManager = {
  header: {
    eyebrow: "Pokoje hotelowe",
    title: "Zarządzanie pokojami",
    subtitle:
      "Utwórz typy pokoi i wygeneruj jednostki fizyczne wraz z ich numeracją. Te pokoje będą synchronizowane z Channex.",
    addRoom: "Dodaj pokój",
  },
  states: {
    loading: "Wczytywanie pokoi...",
    emptyTitle: "Brak pokoi",
    emptySubtitle:
      "Utwórz pierwszy typ pokoju, aby zacząć konfigurować stawki i dostępność w Channex.",
    addFirstRoom: "Dodaj pierwszy pokój",
  },
  card: {
    roomsBadge: "{count} pokój | {count} pokoje | {count} pokoi",
    maxGuests: "Maks. {count} gości",
    editTitle: "Edytuj pokój",
    deleteTitle: "Usuń pokój",
    adults: "{count} dorosły | {count} dorośli | {count} dorosłych",
    children: "{count} dziecko | {count} dzieci | {count} dzieci",
    infants: "{count} niemowlę | {count} niemowlęta | {count} niemowląt",
    units: "Jednostki",
  },
  physical: {
    title: "Pokoje fizyczne",
    subtitle:
      "Edytuj numer lub nazwę każdego pokoju albo przenieś go do innego typu. Jego rezerwacje przechodzą razem z nim. Przeciągaj je za uchwyt, aby ustalić kolejność w obrębie typu: w takiej kolejności zobaczą je Państwo w kalendarzu.",
    roomsCount: "{count} pokój | {count} pokoje | {count} pokoi",
    savingOrder: "Zapisywanie kolejności…",
    selectAll: "Zaznacz wszystko",
    clearSelection: "Wyczyść zaznaczenie",
    dragToOrder: "Przeciągnij, aby zmienić kolejność",
    selectRoom: "Zaznacz: {label}",
    roomFallback: "pokój",
    codePlaceholder: "Nr / kod",
    namePlaceholder: "Nazwa",
  },
  bar: {
    selectedCount: "pokój zaznaczony | pokoje zaznaczone | pokoi zaznaczonych",
    clearSelection: "Wyczyść zaznaczenie",
    changeType: "Zmień typ",
  },
  modal: {
    createTitle: "Nowy pokój",
    editTitle: "Edytuj pokój",
    createSubtitle: "Zdefiniuj typ i wygeneruj jednostki fizyczne",
    editSubtitle: "Zaktualizuj dane typu pokoju",
    basicInfo: "Podstawowe informacje",
    nameLabel: "Nazwa pokoju",
    namePlaceholder: "Np. Pokój dwuosobowy, Junior Suite…",
    descriptionLabel: "Opis",
    optional: "(opcjonalnie)",
    descriptionPlaceholder: "Widok na morze, taras, minibar…",
    inventorySection: "Inwentarz i pojemność",
    countLabel: "Liczba pokoi",
    countHintZero:
      "Utworzony bez pokoi: można potem przypisać do niego istniejące pokoje z listy pokoi fizycznych.",
    countHint: "Łączna liczba jednostek fizycznych tego typu",
    capacityLabel: "Całkowita pojemność (goście)",
    capacityHint: "Maksimum łącznie dla dorosłych + dzieci + niemowląt",
    priceLabel: "Cena za noc",
    priceHint:
      "Tworzy to jego stawkę standardową. Można ją dopracować później w sekcji „Stawki hotelowe”.",
    adultsLabel: "Dorośli",
    childrenLabel: "Dzieci",
    infantsLabel: "Niemowlęta",
    numberingSection: "Numeracja pokoi",
    toggleOn: "Wł.",
    toggleOff: "Wył.",
    numberingHintCreate:
      "Pokoje są tworzone z automatycznym kodem. Można go zmieniać pojedynczo na liście pokoi fizycznych albo ustawić numerację w „Edytuj”, aby kolejne powstawały już z nią.",
    prefixLabel: "Prefiks kodu",
    prefixPlaceholder: "Np. 10  lub  A-",
    prefixHint: 'Np. prefiks "10" + początek 1 → 101, 102…',
    startNumberLabel: "Numer początkowy",
    paddingLabel: "Wypełnienie zerami",
    paddingHint: "3 → 001, 002…",
    nameModeLabel: "Nazwy pokoi fizycznych",
    nameModeType: "Tylko typ",
    nameModeTypeExample: "Dwuosobowy",
    nameModeTypeCode: "Typ + kod",
    nameModeTypeCodeExample: "Dwuosobowy 101",
    preview: {
      lead: "Utworzymy",
      roomsNoun: "pokój | pokoje | pokoi",
      withNumbering: "z tą numeracją. Przykład:",
    },
    numberingHintKeep:
      "Istniejące pokoje zachowują swój numer. Ta numeracja obejmie te, które zostaną dodane od teraz.",
    numberingHintZero:
      "Bez pokoi nie ma czego numerować. Przypisz do niego istniejące pokoje z listy pokoi fizycznych.",
    numberingHintDisabled:
      "Pokoje fizyczne nie będą generowane automatycznie. Można to włączyć w dowolnym momencie.",
    cancel: "Anuluj",
    saving: "Zapisywanie…",
    creating: "Tworzenie…",
    saveChanges: "Zapisz zmiany",
    createRoom: "Utwórz pokój",
  },
  delete: {
    title: "Usuń pokój",
    subtitle: "Tej operacji nie można cofnąć",
    confirmCopy: "Wpisz nazwę pokoju, aby potwierdzić:",
    placeholder: "Nazwa pokoju",
    cancel: "Anuluj",
    deleting: "Usuwanie...",
    confirm: "Usuń",
  },
  change: {
    title: "Zmień typ {target}",
    subtitle: "Numer pokoju się nie zmienia",
    newTypeLabel: "Nowy typ",
    newTypePlaceholder: "Wybierz typ, do którego ma zostać przeniesiony…",
    blocksHead: "Jedna rezerwacja blokuje zmianę | {count} rezerwacje blokują zmianę | {count} rezerwacji blokuje zmianę",
    moves: "Przechodzi do nowego typu",
    stays: "Zostaje w obecnym typie",
    addMissing: "Dodaj do zmiany: {labels} i spróbuj ponownie",
    stockLabel: "Pokoje w sprzedaży",
    checkingReservations: "Sprawdzanie, które rezerwacje są w {target}…",
    thisRoom: "tym pokoju",
    theseRooms: "tych pokojach",
    theRoom: "pokojem",
    theRooms: "pokojami",
    noReservations: "Nie ma rezerwacji w {target}.",
    reservationsLeave: "rezerwacja przechodzi | rezerwacje przechodzą | rezerwacji przechodzi",
    with: "wraz z {target}",
    moreReservations: "i jeszcze {count} rezerwacja | i jeszcze {count} rezerwacje | i jeszcze {count} rezerwacji",
    greyLegend: "Pokoje na szaro zostają w swoim obecnym typie.",
    retry: "Ponów",
    cancel: "Anuluj",
    applying: "Zmienianie…",
    confirm: "Tak, zmień typ",
    titleTargetOne: "pokoju {label}",
    titleTargetMany: "{count} pokoju | {count} pokoi | {count} pokoi",
    textZero: "Te pokoje są już tego typu: wybierz inny, aby je przenieść.",
    textOne:
      "Pokój zachowuje swój numer i swoje rezerwacje: zmienia się tylko typ, w jakim jest sprzedawany. Tam, gdzie jest teraz, będzie o jeden pokój mniej w sprzedaży, a w nowym typie o jeden więcej.",
    textMany:
      "Te pokoje ({count}) zachowują swój numer i swoje rezerwacje: zmienia się tylko typ, w jakim są sprzedawane. Tam, gdzie są teraz, będzie o {count} pokoi mniej w sprzedaży, a w nowym typie o {count} więcej.",
  },
  blockTitles: {
    huespedDentro: "Gość jest po check-inie",
    reservaRepartida: "Rezerwacja zajmuje także inne pokoje",
    reservaSinAsignar: "Rezerwacji brakuje części pokoi",
    fallback: "Nie można przenieść",
  },
  groups: {
    noType: "Brak przypisanego typu",
  },
  reservation: {
    noName: "Bez nazwy",
  },
  toasts: {
    roomsChanged: "Pokój zmienił typ | {count} pokoje zmieniły typ | {count} pokoi zmieniło typ",
    changedSyncing: "{done} · aktualizowanie kanałów",
    created: "Pokój utworzony pomyślnie",
    updated: "Pokój zaktualizowany",
    deleted: "Pokój usunięty",
  },
  errors: {
    generic: "Coś poszło nie tak.",
    loadRooms: "Błąd wczytywania pokoi",
    updateQty: "Nie udało się zaktualizować liczby",
    savePhysicalRoom: "Nie udało się zapisać pokoju",
    saveOrder: "Nie udało się zapisać kolejności pokoi.",
    checkReservations: "Nie udało się sprawdzić, które rezerwacje są w tych pokojach.",
    changeType: "Nie udało się zmienić typu pokoju.",
    noProperty: "Nie udało się pobrać obiektu. Prosimy spróbować ponownie.",
    saveRoom: "Błąd zapisywania pokoju",
    deleteRoom: "Błąd usuwania",
  },
};
